import getListing from "./getListing.api";
import getAccessRight from "./getAccessRight.api";
import updateAdminRole from "./updateAdminRole.api";
import updateAdminCompanyGroup from "./updateAdminCompanyGroup.api";
import updateCompanyGroup from "./updateCompanyGroup.api";
import createCompanyGroup from "./createCompanyGroup.api";
import duplicateCompanyGroup from "./duplicateCompanyGroup.api";
import getCompanyGroups from "./getCompanyGroups.api";
import getCompanyDropdown from "./getAllCompanies.api";
import getCompanyGroupDropdown from "./getCompanyGroupDropdown.api";
import createAdmin from "./createAdmin.api";
import updateAdmin from "./updateAdmin.api";
import updateAdminStatus from "./updateAdminStatus.api";
import bootstrap from "./bootstrap.api";
import updateProfile from "./updateProfile.api";
import resetPassword from "./resetPassword.api";

const adminsApi = {
  getListing,
  getAccessRight,
  updateAdminRole,
  updateAdminCompanyGroup,
  getCompanyGroups,
  createCompanyGroup,
  updateCompanyGroup,
  duplicateCompanyGroup,
  getCompanyDropdown,
  getCompanyGroupDropdown,
  createAdmin,
  updateAdmin,
  updateAdminStatus,
  bootstrap,
  updateProfile,
  resetPassword,
};

export default adminsApi;
